import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import { Input } from '../../components/ui/Input';
import { depositosApi } from '../../api/estoque';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

export default function DepositosList() {
  useTituloPagina('Depósitos');
  const [depositos, setDepositos] = useState([]);
  const [nome, setNome] = useState('');

  const carregar = () => depositosApi.listar().then(setDepositos).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const criar = async (e) => {
    e.preventDefault();
    if (!nome) return;
    await depositosApi.criar({ nome });
    setNome('');
    carregar();
  };

  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <form onSubmit={criar} style={{ display: 'flex', gap: 10 }}>
          <Input placeholder="Nome do depósito/filial" value={nome} onChange={e => setNome(e.target.value)} style={{ flex: 1 }} />
          <Btn type="submit">Adicionar</Btn>
        </form>
      </Card>
      <Card style={{ padding: 0 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead><tr style={{ textAlign: 'left', background: COLORS.bg }}><th style={{ padding: 10 }}>Nome</th><th style={{ padding: 10 }}>Tipo</th></tr></thead>
          <tbody>
            {depositos.map(d => (
              <tr key={d.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10 }}>{d.nome}</td>
                <td style={{ padding: 10 }}>{d.tipo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
